import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';

import { cxHelpers } from 'util/className';

import { RIGHT_COLUMN_WIDTH } from '../constants';

const { cx } = cxHelpers('BaseListItem');

type BaseListItemProps = {
  bg?: string;
  titleI18n: string;
  title?: string;
  date: string;
  icon?: string;
  children: React.ReactNode;
};

const BaseListItem = ({
  titleI18n,
  title,
  date,
  bg,
  children,
}: BaseListItemProps) => (
  <Box className={cx()} mb={10} bbw={1} bgcolor={bg}>
    <Box pt={20} pb={10} ph={30} vcenter>
      <Box grow={1}>
        <Text variant="bodySmBold" i18n={titleI18n}>
          {title}
        </Text>
      </Box>
      <Box
        flex
        justifyContentEnd
        basis={RIGHT_COLUMN_WIDTH}
        minw={RIGHT_COLUMN_WIDTH}
      >
        <Text variant="captions" color="mono900">
          {date}
        </Text>
      </Box>
    </Box>
    <Box pb={20} ph={30}>
      {children}
    </Box>
  </Box>
);

export default BaseListItem;
